import _ from 'lodash';
import React, { HTMLAttributes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormFieldFile, FieldStates } from 'sos-common/js/commonTypes/formField.types';
import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { GroupedComponentsValidator } from 'sos-common/js/components/FormControls/GroupedComponentsValidator';
import { RadioButton } from 'sos-common/js/components/FormControls/RadioButton';
import { RadioButtonGroup } from 'sos-common/js/components/FormControls/RadioButtonGroup';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { StepChildProps } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { Conditional } from '../../../components/ConditionalField';
import { InternalRegistries } from '../../../components/statistics/internalRegistries';
import { StatisticsOrderModel } from '../../../models';
import {
  statisticsOrderFiles,
  StatisticsOrderRegisters,
  StatisticsOrderStore,
} from '../../../models/StatisticsOrderStore.types';
import {
  addFileActionFunc,
  addFilesAction,
  removeFileActionFunc,
  removeFilesAction,
  setFormValue,
  clearError,
  clearErrorDispatcher,
} from 'sos-eservice-common/js/Redux/Actions';
import {
  fileInputAcceptedTypes,
  getErrorMessageByFieldName,
  getErrorMessageByFieldNameAfterHitSummary,
} from '../../../utilities/helpers';
import { makeTranslator, translateFunc } from '../../../utilities/translations';
import { shortuid } from 'sos-common/js';

// todo: complete props
export interface Step1Props extends StepChildProps {
  Translate?: translateFunc;
  files: statisticsOrderFiles;
  validationResults: ValidationResult[];
  orderId: string;
  hasHitSummary: boolean;
  postFile: addFileActionFunc;
  deleteFile: removeFileActionFunc;
  setFormValue?: typeof setFormValue;
  formModel: StatisticsOrderModel;
  registers?: StatisticsOrderRegisters;
  clearError: clearError;
  errors: ClientErrorsState;
}

export interface Step1State {}

class Step1 extends React.Component<Step1Props, Step1State> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  public getTitle = () => 'Projektet';

  public addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  };
  public removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };

  public onChangeField = (field: FieldStates) => {
    this.props.setFormValue(field);
  };

  public componentDidMount() {
    this.props.reportToWizard({
      stepLabel: this.getTitle(),
    });
  }

  private getGroupedErrorMessageObject = (fieldName: string, afterHitSummary: boolean) => {
    const { validationResults, hasHitSummary } = this.props;
    let errorMessage = '';
    if (afterHitSummary) {
      errorMessage = getErrorMessageByFieldNameAfterHitSummary(validationResults, fieldName, hasHitSummary);
    } else {
      errorMessage = getErrorMessageByFieldName(validationResults, fieldName);
    }

    const id = fieldName + '-errormessage';
    let ariaAttributes = {} as HTMLAttributes<any>;
    if (errorMessage) {
      ariaAttributes['aria-invalid'] = true;
      ariaAttributes['aria-describedby'] = id;
    } else {
      ariaAttributes = null;
    }
    return { errorMessage, id, ariaAttributes };
  };

  public render() {
    const {
      Translate,
      formModel: statisticsOrder,
      files,
      orderId: statisticsOrderId,
      hasHitSummary,
      validationResults,
      registers,
      errors,
    } = this.props;
    const noOrderId = !statisticsOrderId;
    const IsUpdateOfPriorOrderErrorMessageObject = this.getGroupedErrorMessageObject('IsUpdateOfPriorOrder', true);

    return (
      <div id="step1" tabIndex={-1}>
        <p>{Translate('/orderFormPage/starOblig')}</p>
        <div className="form-group">
          <label className="inlineblock h2" htmlFor="TitleId">
            {Translate('/statisticsOrderFormPage/title')} *
          </label>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfoBubblorStatistik/TitelForBestalningenPaSvenska')} />
          </div>
          <TextInput
            id="TitleId"
            placeholder={Translate('/statisticsOrderFormPage/titlePH')}
            value={_.get(statisticsOrder, 'Title')}
            isRequired={true}
            maxLength={160}
            fieldName="StatisticsOrder.Title"
            onChange={this.onChangeField}
            errorMessage={getErrorMessageByFieldName(validationResults, 'Title')}
          />
        </div>
        <div className="form-group" role="group" aria-labelledby="updatePriorLabel">
          <h2 id="updatePriorLabel" className="inlineblock">
            {Translate('/statisticsOrderFormPage/updatePrior')} *
          </h2>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfoBubblorStatistik/ArDetEnUppdateringAvEnTidigareBestallning')} />
          </div>
          <label>{Translate('/statisticsOrderFormPage/hanvisning')}</label>
          <GroupedComponentsValidator
            errorId={IsUpdateOfPriorOrderErrorMessageObject.id}
            errorMessage={IsUpdateOfPriorOrderErrorMessageObject.errorMessage}
            delayErrorRender={70}>
            <Conditional showConditional={statisticsOrder.IsUpdateOfPriorOrder}>
              {{
                top: (
                  <div>
                    <RadioButton
                      fieldName="StatisticsOrder.IsUpdateOfPriorOrder"
                      onChange={this.onChangeField}
                      checked={statisticsOrder.IsUpdateOfPriorOrder}
                      value={true}
                      label={Translate('/global/yes')}
                      errorAriaAttributes={IsUpdateOfPriorOrderErrorMessageObject.ariaAttributes}
                      isRequired={true}
                    />
                  </div>
                ),
                bottom: (
                  <div>
                    <RadioButton
                      fieldName="StatisticsOrder.IsUpdateOfPriorOrder"
                      onChange={this.onChangeField}
                      value={false}
                      checked={statisticsOrder.IsUpdateOfPriorOrder !== null && !statisticsOrder.IsUpdateOfPriorOrder}
                      label={Translate('/global/no')}
                      errorAriaAttributes={IsUpdateOfPriorOrderErrorMessageObject.ariaAttributes}
                      isRequired={true}
                    />
                  </div>
                ),
                conditional: (
                  <div>
                    <TextInput
                      placeholder={Translate('/statisticsOrderFormPage/priorOrderRefPH')}
                      fieldName="StatisticsOrder.PriorOrderReference"
                      label={Translate('/statisticsOrderFormPage/duKanHanvisa')}
                      onChange={this.onChangeField}
                      maxLength={160}
                      value={_.get(statisticsOrder, 'PriorOrderReference')}
                      errorMessage={getErrorMessageByFieldName(validationResults, 'PriorOrderReference')}
                    />
                  </div>
                ),
              }}
            </Conditional>
          </GroupedComponentsValidator>
        </div>
        <hr className="formdivider" />

        <div className="form-group" role="group" aria-labelledby="hurOftaLabel">
          <h2 id="hurOftaLabel" className="inlineblock">
            {Translate('/statisticsOrderFormPage/hurOfta')} *
          </h2>
          <div className="inlineblock">
            <Tooltip text={Translate('/InfoBubblorStatistik/HurOftaVillDuAttDinBestallningLevereras')} />
          </div>
          <RadioButtonGroup
            value={_.get(statisticsOrder, 'FrequencyOfDeliveries')}
            fieldName="StatisticsOrder.FrequencyOfDeliveries"
            onChange={this.onChangeField}
            isRequired={true}>
            <RadioButton
              value={Translate('/statisticsOrderFormPage/ettTillfalle')}
              label={Translate('/statisticsOrderFormPage/ettTillfalle')}
            />
            <RadioButton
              value={Translate('/statisticsOrderFormPage/manadsvis')}
              label={Translate('/statisticsOrderFormPage/manadsvis')}
            />
            <RadioButton
              value={Translate('/statisticsOrderFormPage/kvartalsvis')}
              label={Translate('/statisticsOrderFormPage/kvartalsvis')}
            />
            <RadioButton
              value={Translate('/statisticsOrderFormPage/halvarsvis')}
              label={Translate('/statisticsOrderFormPage/halvarsvis')}
            />
          </RadioButtonGroup>
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <div>
            <label className="inlineblock h2" htmlFor="AdditionalInformationId">
              {Translate('/statisticsOrderFormPage/angeInformation')}
            </label>
            <div className="inlineblock">
              <Tooltip text={Translate('/InfoBubblorStatistik/AngeInfoForLattHanteringBestallning')} />
            </div>
          </div>
          <div className="form-group">
            <TextInput
              id="AdditionalInformationId"
              fieldName="StatisticsOrder.AdditionalInformation"
              classNames="height240px"
              placeholder={Translate('/statisticsOrderFormPage/fritext')}
              multiline={true}
              maxLength={4000}
              value={_.get(statisticsOrder, 'AdditionalInformation')}
              onChange={this.onChangeField}
              errorMessage={getErrorMessageByFieldName(validationResults, 'AdditionalInformation')}
            />
          </div>
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <h2 className="inlineblock">{Translate('statisticsOrderFormPage/vilkaregister')} *</h2>
          <InternalRegistries
            Translate={Translate}
            fieldName="StatisticsOrder.Registers"
            value={_.get(statisticsOrder, 'Registers', [])}
            onChange={this.onChangeField}
            registers={registers}
            validationResults={validationResults}
          />
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <div className="inlineblock">
            <label className="inlineblock h2" htmlFor="ConstraintsId">
              {Translate('/statisticsOrderFormPage/beskrivnoga')} *
            </label>
            <div className="inlineblock">
              <Tooltip text={Translate('/InfoBubblorStatistik/BeskrivNogaHurDinBestallningSkaAvgansas')} />
            </div>
          </div>

          <TextInput
            id="ConstraintsId"
            fieldName="StatisticsOrder.Constraints"
            placeholder={Translate('/statisticsOrderFormPage/angeurvalskriterier')}
            onChange={this.onChangeField}
            multiline={true}
            classNames="height240px"
            maxLength={4000}
            value={_.get(statisticsOrder, 'Constraints', '')}
            errorMessage={getErrorMessageByFieldName(validationResults, 'StatisticsOrder.Constraints')}
            isRequired={true}
          />
        </div>

        <hr className="formdivider" />

        <div className="form-group">
          <div className="inlineblock">
            <label className="inlineblock h2" htmlFor="PresentationId">
              {Translate('/statisticsOrderFormPage/beskrivtabell')} *
            </label>
            <div className="inlineblock">
              <Tooltip text={Translate('/InfoBubblorStatistik/BeskrivHurDinTabellSkaPresenteras')} />
            </div>
          </div>

          <TextInput
            id="PresentationId"
            fieldName="StatisticsOrder.Presentation"
            placeholder={Translate('/statisticsOrderFormPage/presentationPH')}
            multiline={true}
            classNames="height240px"
            maxLength={4000}
            onChange={this.onChangeField}
            value={_.get(statisticsOrder, 'Presentation', '')}
            errorMessage={getErrorMessageByFieldName(validationResults, 'StatisticsOrder.Presentation')}
            isRequired={true}
          />
        </div>
        <div className="form-group">
          <h2 className="inlineblock">{Translate('/statisticsOrderFormPage/bifogafil')}</h2>
          <Fileupload
            disabled={noOrderId}
            heading={Translate('/statisticsOrderFormPage/uploadheader')}
            upload={Translate('/orderformpage/uploadFile')}
            nofilesText={Translate('/orderformpage/noFilesUploaded')}
            fieldName="exempelltabell"
            mimetype={fileInputAcceptedTypes}
            value={files.exempelltabell}
            onAdd={this.addFiles}
            onRemove={this.removeFile}
            max={5}
            clientError={errors['exempelltabell'] as clientError}
            allowedFileTypesText={'Tillåtna format: PDF, Word, Excel, PowerPoint, text och bilder. Max 10 MB.'}
          />
        </div>
        <hr className="formdivider" />
      </div>
    );
  }
}

const mapState2Props = (state: StatisticsOrderStore) => {
  return {
    errors: state.errors,
    files: state.files,
    formModel: state.formModel,
    orderId: state.globals.orderId,
    hasHitSummary: state.globals.hasHitSummary,
    registers: state.registers,
    stepValidationMap: state.validationState.stepValidationMap,
    Translate: makeTranslator(state.globals.translations),
    validationResults: state.validationState.validationResults,
  } as Partial<Step1Props>;
};

const mapDispatch2Props = (dispatch) => {
  return {
    clearError: clearErrorDispatcher(dispatch),
    deleteFile: bindActionCreators(removeFilesAction, dispatch),
    postFile: bindActionCreators(addFilesAction, dispatch),
    setFormValue: bindActionCreators(setFormValue, dispatch),
  };
};

const StepOne = connect(mapState2Props, mapDispatch2Props)(Step1);
export { StepOne };
